/**
 * Запущено ли как приложение.
 * Не в табе браузера.
 */
export const isStandalone = () =>
  process.env.browser && window.matchMedia('(display-mode: standalone)').matches
